export default "__VITE_ASSET__LlxRab8X__"